module.exports = __webpack_public_path__ + "10c9be581967fd953d7a8944cdd1a24e.png";